import {
  TASK_MASTER_LIST,
  PROJECT_DROPDOWN,
  CREATE_TASK,
  TASK_DATA_EDIT,
  TASK_TRANSACTION_LIST,
  TASK_REPORT_EMP_WISE,
  TASK_STATUS,
  TASK_PRIORITY,
  TASK_TYPE,
  TASK_ASSIGN_LIST,
  TASK_COMMENT,
  TASK_WORKLOG,
  TASK_WORKLOG_DATA,
  TASK_COMMENT_DATA,
  TASK_MASTER_DASH_DATA,
  TASK_NO_SEARCH_LIST,
  TASK_DETAILS,
  FETCH_WORKLOG_DATA,
  FETCH_TASK_PROJECTWISE_DATA,
  TODAYS_WORKLOG_DATA_BYID,
  EMP_TASK_COUNT_LIST,
  PROJECT_AS_LOGINID,
} from "./ActionType";

const initialValue = {
  tasklist: [],
  getprojectDropdownData: [],
  getProjectAsLoginId: [],
  createTaskData: [],
  taskEdit: [],
  taskReport: [],
  taskStatus: [],
  taskPriority: [],
  taskType: [],
  taskAssignList: [],
  taskComment: [],
  taskWorklog: [],
  taskWorklogdata: [],
  taskCommentData: [],
  taskDashboardData: [],
  taskSearchList: [],
  allTaskDetails: [],
  fetchWorklogData: [],
  projectWiseData: {},
  todaysWorklogDataByid: [],
  taskTransactionList: {},
  empTaskContList: [],
};

export const taskReducer = (store = initialValue, { type, payload }) => {
  if (type === TASK_MASTER_LIST) {
    return { ...store, tasklist: payload || [] };
  } else if (type === PROJECT_DROPDOWN) {
    return { ...store, getprojectDropdownData: payload.projectMaster || [] };
  } else if (type === CREATE_TASK) {
    return { ...store, createTaskData: payload };
  } else if (type === TASK_DATA_EDIT) {
    return { ...store, taskEdit: payload.taskMaster || [] };
  } else if (type === TASK_REPORT_EMP_WISE) {
    return { ...store, taskReport: payload };
  } else if (type === TASK_STATUS) {
    return { ...store, taskStatus: payload.ticketStatus || [] };
  } else if (type === TASK_PRIORITY) {
    return { ...store, taskPriority: payload.ticketPriority || [] };
  } else if (type === TASK_TYPE) {
    return { ...store, taskType: payload.ticketType || [] };
  } else if (type === TASK_ASSIGN_LIST) {
    return { ...store, taskAssignList: payload || [] };
  } else if (type === TASK_COMMENT) {
    return { ...store, taskComment: payload };
  } else if (type === TASK_WORKLOG) {
    return { ...store, taskWorklog: payload };
  } else if (type === TASK_WORKLOG_DATA) {
    return { ...store, taskWorklogdata: payload.taskWorkLogList || [] };
  } else if (type === TASK_COMMENT_DATA) {
    return { ...store, taskCommentData: payload.taskCommentsDto || [] };
  } else if (type === TASK_MASTER_DASH_DATA) {
    return { ...store, taskDashboardData: payload || [] };
  } else if (type === TASK_NO_SEARCH_LIST) {
    return { ...store, taskSearchList: payload.taskMaster || [] };
  } else if (type === TASK_DETAILS) {
    return { ...store, allTaskDetails: payload || [] };
  } else if (type === FETCH_WORKLOG_DATA) {
    return { ...store, fetchWorklogData: payload || [] };
  } else if (type === FETCH_TASK_PROJECTWISE_DATA) {
    return { ...store, projectWiseData: payload || {} };
  } else if (type === TODAYS_WORKLOG_DATA_BYID) {
    return { ...store, todaysWorklogDataByid: payload || [] };
  } else if (type === TASK_TRANSACTION_LIST) {
    return { ...store, taskTransactionList: payload.taskTranList || {} };
  } else if (type === EMP_TASK_COUNT_LIST) {
    return { ...store, empTaskContList: payload || [] };
  } else if (type === PROJECT_AS_LOGINID) {
    return { ...store, getProjectAsLoginId: payload.projectMaster || [] };
  }
  return store;
};
